export default __webpack_public_path__ + "assets/increase-revenue.691a30f0.svg";